import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { toast } from 'react-toastify';

import { sessionActions } from '../../../../../../store';

export function useDownloadSessionNote(sessionId: string | undefined) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [openConfirmDownload, setOpenConfirmDownload] = useState(false);

  const handleDownloadSessionNote = useCallback(async () => {
    if (!sessionId) return;
    setOpenConfirmDownload(false);

    const response = await dispatch(
      sessionActions.downloadSessionNote({ sessionId, getAccessTokenSilently }),
    );

    if (response.payload?.document_url) {
      window.location.href = response.payload.document_url;
      toast.success('Session note downloaded');
    } else if (response.error?.message) {
      toast.error(response.error.message);
    } else {
      toast.error('Something went wrong while downloading the pdf');
    }
  }, [dispatch, getAccessTokenSilently, sessionId]);

  return {
    openConfirmDownload,
    setOpenConfirmDownload,
    handleDownloadSessionNote,
  };
}
